import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "posthog-js/react";

export function PostHogPageview() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.capture("$pageview", { $current_url: window.location.href });
  }, [location.pathname, location.search, posthog]);

  return null;
}
